<template>
  <div class="inner_box">
    <div class="left_box" :style="{width:leftWidth+'px',minWidth:leftWidth+'px'}">
      <div><span :class="['line_title', langClass]">{{ $t('effective.points') }}</span>
        <span class="txt" v-if="!route.query.searchType">
          {{
            $t('userinfo.AI.number', {
              number: userDataInformation?.totalAiNum
                  ? Number(userDataInformation.totalAiNum).toFixed(2)
                  : (0).toFixed(2)
            })
          }}
        </span>
        <span class="txt" v-else>
         {{
            $t('userinfo.AI.number', {
              number: Number(totalAiNum || 0).toFixed(2)
            })
          }}
        </span>
        <el-button v-if="showDetailButton" style="margin-left:6px;" type="primary" link @click="showStationDetails">{{$t('common.des.product')}}</el-button>
      </div>
      <div>
        <span :class="['line_title', langClass]">{{ $t('AI.use.text') }}</span>
        <span class="txt">
          {{
            $t('userinfo.AI.number', {number: useDetailNum?.toFixed(2)})
          }}
      </span>
      </div>
      <div><span :class="['line_title', langClass]">{{ $t('AI.available.number') }}</span><span
          class="txt" v-if="!route.query.searchType">{{
          $t('userinfo.AI.number', {
            number: Number(userDataInformation?.freeAiNum ?? 0)?.toFixed(2)
          })
        }}</span>
        <span class="txt" v-else>
          {{
            $t('userinfo.AI.number', {number: freeAiNum})
          }}
        </span>
      </div>
    </div>
    <div class="right_box">
      <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="loading"
          :header-cell-style="{'text-align': 'left', fontSize:'14px',color:'color: rgba(0,0,0,.85);', fontWeight: '500',background: '#f9f9f9', color: 'black', padding: '8px 0px'}"
      >
        <el-table-column prop="useTime" :label="$t('common.time.use')" width="auto"/>
        <el-table-column prop="userName" :label="$t('userinfo.edm.detail')" width="auto"/>
        <!--        <el-table-column prop="taskCode" :label="$t('sending.customer.search.no')"/>-->
        <el-table-column prop="aiType" :label="$t('ai.point.origin')">
          <template #default="{row}">
            <el-button v-if="row?.aiType===1" link>{{ $t('ai.title') }}</el-button>
            <el-button v-else link>{{ $t('ai.email.title') }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="useNum" :label="$t('userinfo.edm.user.number')">
          <template #default="{row}">
            {{ row.useNum.toFixed(2) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pages">
        <el-pagination
            size="small"
            v-model:current-page="current"
            v-model:page-size="size"
            background
            v-if="totals"
            :total="totals"
            layout="total, prev, pager, next, jumper"
            @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>

  <!-- AI点数明细对话框 -->
  <el-dialog
      v-model="dialogVisibleDetails"
      title="智能点数 明细"
      width="800px"
      :close-on-click-modal="false"
  >
    <div class="resource-details">
      <div class="resource-details__table-wrap">
        <el-table
            class="resource-details__table"
            v-loading="resourceDetailLoading"
            :data="resourceDetailList"
            style="width: 100%"
        >
          <el-table-column prop="resource" label="智能点数" width="auto">
            <template #default="scope">
              {{ $t('userinfo.AI.number', {number: Number(scope.row.resource ?? 0).toFixed(2)}) }}
            </template>
          </el-table-column>
          <el-table-column prop="type" label="来源类型" width="auto">
            <template #default="scope">
              {{ getResourceSourceTypeText(scope.row.type) }}
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="开始时间" width="auto">
            <template #default="scope">
              {{ scope.row.startTime ? toISODateTime(scope.row.startTime) : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="endTime" label="结束时间" width="auto">
            <template #default="scope">
              {{ scope.row.endTime ? toISODateTime(scope.row.endTime) : '-' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pages" v-if="resourceDetailTotal">
        <el-pagination
            size="small"
            v-model:current-page="resourceDetailCurrent"
            v-model:page-size="resourceDetailSize"
            background
            layout="total, prev, pager, next"
            :total="resourceDetailTotal"
            @current-change="handleResourceDetailCurrentChange"
        />
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="small" @click="dialogVisibleDetails = false">{{ $t('common.close') }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script setup>
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {ElMessage} from "element-plus";
import {getCompanyAccountDataDetail, getPersonAndCompanyInfoDataDetail} from "@/api/cloud";
import {useRoute} from "vue-router";
import {toISODateTime} from "@/views/Home/utils";
import {queryMailResourceSourcePageList} from "@/api/usercenter";
import {
  getResourceDetailPageData,
  getResourceSourceTypeText,
  RESOURCE_DETAIL_PAGE_SIZE
} from "@/views/UserCenter/resourceDetail";

const store = useStore()
/**
 * 文件存储的空间大小
 */
const isNormalUser = computed(() => store.getters["user/isNormalUser"])
const spaceSize = computed(() => store.state.cloud.spaceSize)
const userDataInformation = computed(() => store.state.cloud.userDataInformation)
const isEnterpriseMainUser = computed(() => store.getters['user/isEnterpriseMainUser'])
const isEnterpriseChildUser = computed(() => store.getters['user/isEnterpriseChildUser'])
const route = useRoute()
const {leftWidth, showDetailButton} = defineProps({
  leftWidth: {
    type: Number,
    default: 450,
  },
  showDetailButton: {
    type: Boolean,
    default: true
  }
})

// 分页
const current = ref(1);
const size = ref(10);
const totals = ref(0)
const loading = ref(false)
const tableData = ref([])
const handleCurrentChange = async (page) => {
  current.value = page;
  if (!route.query.searchType || isNormalUser.value) {
    await getTableAIList()
  } else {
    await getPersonAndCompanyInfoDataDetailApis()
  }
};

const mailContainDataVoList = ref([])
const freeAiNum = ref(0)
const totalAiNum = ref(0)
const useDetailNum = ref(0)
const resourceDetailLoading = ref(false)
const resourceDetailList = ref([])
const resourceDetailCurrent = ref(1)
const resourceDetailSize = ref(RESOURCE_DETAIL_PAGE_SIZE)
const resourceDetailTotal = ref(0)

const getTableAIList = async () => {
  const payload = {
    pageSize: size.value,
    pageNo: current.value,
    type: 3
  }
  try {
    loading.value = true
    const res = await getCompanyAccountDataDetail(payload)
    if (res.code !== 200) {
      ElMessage.error(res.message)
      return;
    }
    loading.value = false
    mailContainDataVoList.value = res.result.mailContainDataVoList;
    tableData.value = res.result.useDetailData?.records;
    current.value = res.result.useDetailData?.current;
    totals.value = res.result.useDetailData?.total;
    freeAiNum.value = res.result.freeAiNum;
    totalAiNum.value = res.result.totalAiNum;
    useDetailNum.value = res.result.useDetailNum;
  } catch (e) {
    loading.value = false;
  }
}

// 企业主账号详情
const getPersonAndCompanyInfoDataDetailApis = async () => {
  const payload = {
    pageSize: size.value,
    pageNo: current.value,
    type: 3,
  }
  if (route.query.searchType) {
    payload.searchType = route.query.searchType * 1
  } else {
    if (isEnterpriseMainUser.value || isNormalUser.value) {
      payload.searchType = 2
    } else if (isEnterpriseChildUser.value) {
      payload.searchType = 1
    }
  }
  const res = await getPersonAndCompanyInfoDataDetail(payload)
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return;
  }
  mailContainDataVoList.value = res.result.mailContainDataVoList;
  tableData.value = res.result.useDetailData.records;
  current.value = res.result.useDetailData.current;
  totals.value = res.result.useDetailData.total;
  freeAiNum.value = res.result.freeAiNum;
  totalAiNum.value = res.result.totalAiNum;
  useDetailNum.value = res.result.useDetailNum;
}

onMounted(async () => {
  if (!route.query.searchType || isNormalUser.value) {
    await getTableAIList()
  } else {
    await getPersonAndCompanyInfoDataDetailApis()
  }
})

const lang = computed(() => store.state.system.langLocal)
const langClass = computed(() => {
  return lang.value !== 'zh-CN' ? 'lang-en' : 'lang-zh'
})

// 对话框显示控制
const dialogVisibleDetails = ref(false)

const queryResourceDetailApis = async () => {
  resourceDetailLoading.value = true
  try {
    const res = await queryMailResourceSourcePageList({
      pageNo: resourceDetailCurrent.value,
      pageSize: resourceDetailSize.value,
      productType: 4
    })
    if (res.code !== 200) {
      ElMessage.error(res.message)
      return
    }
    const pageData = getResourceDetailPageData(res.result)
    resourceDetailList.value = pageData.records.map((item) => ({
      ...item,
      resource: item?.resource ?? item?.containData
    }))
    resourceDetailCurrent.value = pageData.current
    resourceDetailSize.value = pageData.size
    resourceDetailTotal.value = pageData.total
  } finally {
    resourceDetailLoading.value = false
  }
}

const handleResourceDetailCurrentChange = async (page) => {
  resourceDetailCurrent.value = page
  await queryResourceDetailApis()
}

// 显示AI点数明细对话框
const showStationDetails = async () => {
  resourceDetailCurrent.value = 1
  dialogVisibleDetails.value = true
  await queryResourceDetailApis()
}
</script>

<style lang="less" scoped>
.inners {
  width: auto !important;
  max-width: 1200px !important;
  position: relative;
}

.right {
  height: auto !important;
  min-height: 640px !important;
  padding-bottom: 70px !important;
}

.inner_box {
  display: flex;
  flex-direction: column;

  .left_box {
    div {
      margin-bottom: 10px;
    }
  }

  .right_box {
    margin-top: 15px;
    width: 100%;
    flex: 1 1;
  }
}

.line_title {
  display: inline-block;
  width: max-content;
  min-width: 80px;
  color: #999;
  font-size: 14px;
}

.line_title.lang-zh {
  min-width: 80px;
}

.line_title.lang-en {
  text-align: right;
  min-width: 120px;
}


.txt {
  display: inline-block;
  color: #333;
  font-size: 14px;
  margin-left: 10px;
}

.results {
  width: 100%;
  border-top: 1px solid #e8e8e8;
  height: 53px;
  bottom: 0px;
  left: 0px;
  position: absolute;
  display: flex;
  justify-content: space-between;

  .buttons_pays {
    padding: 0 35px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background: #d93737;
    margin-left: auto;
    cursor: pointer;
  }
}

.content_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  width: max-content;
  margin-left: 10px;
}

.pages {
  display: flex;
  justify-content: flex-end;
}

.resource-details {
  width: 100%;
  padding: 10px 0;
  box-sizing: border-box;
}

.resource-details__table-wrap {
  width: 100%;
  overflow: hidden;

  :deep(.el-table) {
    width: 100% !important;
    font-size: 13px;
  }

  :deep(.el-table__header-wrapper table),
  :deep(.el-table__body-wrapper table) {
    width: 100% !important;
  }

  :deep(.el-table__header th.el-table__cell) {
    background: #f9f9f9 !important;
    color: rgba(0, 0, 0, .85) !important;
    font-weight: 500;
  }

  :deep(.el-table__cell) {
    padding: 10px 0;
  }

  :deep(.el-table .cell) {
    font-size: 13px !important;
    font-weight: normal !important;
    color: rgba(0, 0, 0, .85);
  }

  :deep(.el-table__row:hover > td.el-table__cell) {
    background: #fafafa;
  }
}

.resource-details .pages {
  margin-top: 12px;
}
</style>
